/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Name_TitleInputs */

const en_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your name`)
};

const ar_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى إدخال اسمك`)
};

const bn_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার নাম লিখুন`)
};

const de_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie Ihren Namen ein`)
};

const es_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor ingresa tu nombre`)
};

const fr_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer votre nom`)
};

const pt_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, digite seu nome`)
};

const zh_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的姓名`)
};

const tr_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen adınızı girin`)
};

const ru_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите свое имя`)
};

const pl_form_name_title = /** @type {(inputs: Form_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proszę podać swoje imię i nazwisko`)
};

/**
* | output |
* | --- |
* | "Please enter your name" |
*
* @param {Form_Name_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_name_title = /** @type {((inputs?: Form_Name_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Name_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_name_title(inputs)
	if (locale === "bn") return bn_form_name_title(inputs)
	if (locale === "de") return de_form_name_title(inputs)
	if (locale === "es") return es_form_name_title(inputs)
	if (locale === "fr") return fr_form_name_title(inputs)
	if (locale === "pt") return pt_form_name_title(inputs)
	if (locale === "zh") return zh_form_name_title(inputs)
	if (locale === "tr") return tr_form_name_title(inputs)
	if (locale === "ru") return ru_form_name_title(inputs)
	if (locale === "pl") return pl_form_name_title(inputs)
	return en_form_name_title(inputs)
});